export default __webpack_public_path__ + "static/certificates-results-2-2b0fbeff56d57699636572021fc0277a.png";